<pg-home-section-1>
  <section id="home-section-1" style="background-color: #F2EEEB;">
    <div class="hero-bg"></div>
  </section>

  <script>
    import './pg-home-section-1.scss'

    export default {
      onBeforeMount(){
      },
      onMounted(){
        // set nav color based on sub session bg color
        this.setMainSectionStyle(0)
      },
      setMainSectionStyle (carouselIdx) {
        const selectedEl = this.$$('#home-section-1')[carouselIdx]
        const selectedStyle = window.getComputedStyle(selectedEl)
        const mainSection = this.$('#home-section-1')
        mainSection.style.backgroundColor = selectedStyle.backgroundColor
        mainSection.style.backgroundImage = selectedStyle.backgroundImage
        mainSection.style.backgroundAttachment = selectedStyle.backgroundAttachment
        mainSection.style.backgroundPositionX = selectedStyle.backgroundPositionX
        mainSection.style.backgroundPositionY = selectedStyle.backgroundPositionY
        mainSection.style.backgroundSize= selectedStyle.backgroundSize
      },
      carouselChange (idx) {
        this.setMainSectionStyle(idx)
        window.dispatchEvent(new Event('force-nav-change'))
      }
    }
  </script>
</pg-home-section-1>
